var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGrip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6.5)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 24,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 3,
    rx: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGrip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-grip.cdc301218a8f0de631e79916aa942854.svg";